var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"temporal-token-exchange"},[(_vm.loading)?_c('div',[_vm._v("Exchanging token...")]):(_vm.error)?_c('div',[_vm._v(_vm._s(_vm.error))]):_c('div',[_vm._v("Redirecting...")])])}
var staticRenderFns = []

export { render, staticRenderFns }